import ThumbList from '.';
import Thumb from './components/thumb';
import ThumbTitle from './components/thumbtitle';
import ThumbSubtext from './components/thumbsubtext';
import ThumbInfo from './components/thumbinfo';

export default angular.module('edge.platform.widgets.thumblist', [])
    .component('gwThumbList', ThumbList)
    .component('gwThumb', Thumb)
    .component('gwThumbTitle', ThumbTitle)
    .component('gwThumbSubtext', ThumbSubtext)
    .component('gwThumbInfo', ThumbInfo);
